import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Grid,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import Header from "../../components/Header";
import { tokens } from "../../theme";

const ViewCoupon = () => {
  const { id } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [coupon, setCoupon] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("accessToken");

  useEffect(() => {
    fetchCouponDetails();
  }, [id]);

  const fetchCouponDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://backend.placemyfilms.com/payapi/getCouponById/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      if (response.data.result) {
        setCoupon(response.data.result);
      } else {
        setError("Failed to fetch coupon details");
      }
    } catch (err) {
      setError(`Error fetching coupon details: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const formatFieldName = (field) => {
    return field.replace(/([A-Z])/g, " $1").trim();
  };

  const formatValue = (field, value) => {
    if (field.toLowerCase().includes('at') && value) {
      return new Date(value).toLocaleString();
    }
    return value !== null && value !== "" ? value : "Not Available";
  };

  const determineCouponStatus = (coupon) => {
    // If status is explicitly 'Active', return 'Active'
    if (coupon.status && coupon.status.toLowerCase() === 'active') {
      return 'Active';
    }
    return 'Inactive';
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box m="20px">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  if (!coupon) {
    return (
      <Box m="20px">
        <Typography variant="h6">No coupon details found.</Typography>
      </Box>
    );
  }

  const couponStatus = determineCouponStatus(coupon);

  return (
    <Box m="20px" height="70vh" overflow="auto" paddingRight="20px">
      <Header title="View Coupon Details" subtitle={`Coupon ID: ${id}`} />
      <Box ml={"40px"}>
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Typography
            variant="h6"
            fontWeight="bold"
            mb={2}
            color={colors.blueAccent[400]}
          >
            Coupon Information
          </Typography>
          <Grid container spacing={2}>
            {Object.entries(coupon).map(([field, value]) => (
              <Grid item xs={12} key={field}>
                <Grid container>
                  <Grid item xs={3}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {formatFieldName(field)}:
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Typography>
                      {field.toLowerCase() === 'status' 
                        ? couponStatus 
                        : formatValue(field, value)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Box>
    </Box>
  );
};

export default ViewCoupon;